import { render, staticRenderFns } from "./OrticDivTable.vue?vue&type=template&id=d92ea0e8&"
import script from "./OrticDivTable.vue?vue&type=script&lang=js&"
export * from "./OrticDivTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports